export const hostType = {
  HOST: 1,
  DOUBLEHOST: 2,
  SUPERHOST: 3
}

export const capacityToHuman = {
  '1': '12 or fewer',
  '2': '13 - 24',
  '3': 'More than 24',
}

export const sharePreferences = {
  NO: 1,
  ANON: 2,
  YES: 3
}

export const invitationDate = {
  THURSDAY: '0',
  FRIDAY: '1',
  SATURDAY: '2',
  SUNDAY: '3',
}

export const invitationDateSelect = [
  4,
  5,
  0,
  1,
  2,
  3,
  8,
  7,
  6,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  16,
  17,
  18,
  19,
  20,
  21,
  22,
  23,
  24,
]

export const invitationDateLabels = [
  "Thursday, September 13",
  "Friday, September 14",
  "Saturday, September 15",
  "Sunday, September 16",
  "Thursday, September 6",
  "Wednesday, September 12",
  "Wednesday, September 19",
  "Tuesday, September 18",
  "Monday, September 17",
  "Thursday, September 20",
  "Friday, September 21",
  "Saturday, September 22",
  "Sunday, September 23",
  "Monday, September 24",
  "Tuesday, September 25",
  "Wednesday, September 26",
  "Thursday, September 27",
  "Friday, September 28",
  "Saturday, September 29",
  "Sunday, September 30",
  "Monday, October 1",
  "Tuesday, October 2",
  "Wednesday, October 3",
  "Thursday, October 4",
  "Friday, October 5",
]

export const invitationTime = {
  AM: "am",
  PM: "pm",
}
